import React from "react"

const RegisterOfflineProductFiller = () => {
  const MIN_HEIGHT = 400
  const style = { minHeight: `${MIN_HEIGHT}px` }

  return <div style={style} className="register-offline-product"></div>
}

export default RegisterOfflineProductFiller
